"use strict";

module.exports = function (h, right) {
  return function (column) {
    if (!this.sortable(column)) return '';
    return h("span", {
      "class": "VueTables__sort-icon ".concat(right, " ").concat(this.sortableChevronClass(column))
    });
  };
};


//////////////////
// WEBPACK FOOTER
// ./~/vue-tables-2/compiled/modules/sort-control.js
// module id = 1677
// module chunks = 61